<div class="booking-summary-section flex" [ngClass]="innerClass">
  <div class="ps-xsmall-r ps-xxsmall-t dn-tablet" [class.ms-small-t]="!title">
    <fcom-icon *ngIf="icon" class="icon-medium {{ innerIconClass }}" [name]="icon" />
  </div>
  <div class="flex-5">
    <h2 *ngIf="title" class="nordic-blue-900-text ms-xsmall-b" [ngClass]="titleClass">
      {{ title | finLocalization }}
    </h2>
    <div *ngIf="isContent" class="content ms-small-t">
      <ng-content />
    </div>
    <div *ngIf="isChangeButton" [ngClass]="!skipEditAlign && 'align-right'">
      <button
        class="edit-button nordic-blue-900-text font-body-1 underline blue-light-hover"
        [finElemTracker]="title"
        [finElemContext]="trackingContext + '-basket'"
        [finElemType]="C.ElementTypes.BUTTON"
        [disabled]="isDisabled"
        (click)="edit.emit(true)"
      >
        {{ editText || ('actions.edit' | finLocalization) }}
      </button>
    </div>
  </div>
</div>
